/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    value: PropTypes.number.isRequired,
    color: PropTypes.oneOf(['orange', 'green', 'red']),
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'green',
};

const ProgressBar = (props) => {
    const classNames = [
        'c-progressbar',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    const style = {
        width: `${props.value}%`,
    };
    const contentClassName = `c-progressbar__content_color_${props.color} c-progressbar__content`;
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div
                className={contentClassName}
                style={style}
            />
        </props.componentClass>
    );
};

ProgressBar.propTypes = propTypes;

ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
